var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "item-con",
      class: { "large-font-mode": _vm.pageData.largeFontMode },
    },
    [
      _vm._m(0),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "flex flex-row" },
          [
            _c(
              "el-form",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  "label-width": "80px",
                  size: "small",
                  inline: "",
                  disabled:
                    ["2", "3", "4"].indexOf(
                      _vm.pageData.activeDiagRecord.diagRecord.stateSign
                    ) > -1,
                },
              },
              [
                _vm.pageData.type == 4
                  ? _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "treatment-form-item",
                                attrs: { label: "主诉" },
                              },
                              [
                                _c("key-word2", {
                                  attrs: { code: "sym" },
                                  model: {
                                    value:
                                      _vm.pageData.activeDiagRecord
                                        .treatmentRecord.symContent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.activeDiagRecord
                                          .treatmentRecord,
                                        "symContent",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.activeDiagRecord.treatmentRecord.symContent",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "treatment-form-item",
                                attrs: { label: "四诊" },
                              },
                              [
                                _c("key-word2", {
                                  attrs: { code: "fdm" },
                                  model: {
                                    value:
                                      _vm.pageData.activeDiagRecord
                                        .treatmentRecord.fdmContent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.activeDiagRecord
                                          .treatmentRecord,
                                        "fdmContent",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.activeDiagRecord.treatmentRecord.fdmContent",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "treatment-form-item",
                                attrs: { label: "中医病" },
                              },
                              [
                                _c("key-word2", {
                                  attrs: { code: "chDiag" },
                                  model: {
                                    value:
                                      _vm.pageData.activeDiagRecord
                                        .treatmentRecord.chDiagContent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.activeDiagRecord
                                          .treatmentRecord,
                                        "chDiagContent",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.activeDiagRecord.treatmentRecord.chDiagContent",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "treatment-form-item",
                                attrs: { label: "中医症" },
                              },
                              [
                                _c("key-word2", {
                                  attrs: { code: "chYndrome" },
                                  model: {
                                    value:
                                      _vm.pageData.activeDiagRecord
                                        .treatmentRecord.chYndromeContent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.activeDiagRecord
                                          .treatmentRecord,
                                        "chYndromeContent",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.activeDiagRecord.treatmentRecord.chYndromeContent",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c(
                      "el-row",
                      [
                        _vm.pageData.type == 1 || _vm.pageData.type == 4
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "treatment-form-item",
                                    attrs: { label: "中医病" },
                                  },
                                  [
                                    _c("key-word", {
                                      key: "chDiag-" + _vm.pageData.type,
                                      attrs: {
                                        id: "key1",
                                        code: "chDiag",
                                        placeholder:
                                          _vm.placeholderMap["chDiag"],
                                      },
                                      on: {
                                        change: _vm.handleOtherFieldChange,
                                      },
                                      model: {
                                        value:
                                          _vm.pageData.activeDiagRecord
                                            .treatmentRecord.chDiagContent,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.pageData.activeDiagRecord
                                              .treatmentRecord,
                                            "chDiagContent",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "pageData.activeDiagRecord.treatmentRecord.chDiagContent",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.pageData.type == 3 || _vm.pageData.type == 4
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "treatment-form-item",
                                    attrs: { label: "中医症" },
                                  },
                                  [
                                    _c("key-word", {
                                      key: "sym-" + _vm.pageData.type,
                                      attrs: {
                                        id: "key2",
                                        code: "sym",
                                        placeholder: _vm.placeholderMap["sym"],
                                        "query-params": {
                                          symDictionaryCommonSign: "1",
                                          symDictionaryMainSign: "1",
                                        },
                                      },
                                      on: {
                                        change: _vm.handleOtherFieldChange,
                                      },
                                      model: {
                                        value:
                                          _vm.pageData.activeDiagRecord
                                            .treatmentRecord.chYndromeContent,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.pageData.activeDiagRecord
                                              .treatmentRecord,
                                            "chYndromeContent",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "pageData.activeDiagRecord.treatmentRecord.chYndromeContent",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.pageData.type == 2 || _vm.pageData.type == 4
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "treatment-form-item",
                                    attrs: { label: "西医病" },
                                  },
                                  [
                                    _c("key-word", {
                                      key: "diag-" + _vm.pageData.type,
                                      attrs: {
                                        id: "key3",
                                        code: "diag",
                                        placeholder: _vm.placeholderMap["diag"],
                                      },
                                      on: {
                                        change: _vm.handleOtherFieldChange,
                                      },
                                      model: {
                                        value:
                                          _vm.pageData.activeDiagRecord
                                            .treatmentRecord.diagContent,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.pageData.activeDiagRecord
                                              .treatmentRecord,
                                            "diagContent",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "pageData.activeDiagRecord.treatmentRecord.diagContent",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "treatment-form-item",
                                attrs: { label: "主诉" },
                              },
                              [
                                _c("chief-complaint", {
                                  attrs: { "diag-params": _vm.diagParams },
                                  model: {
                                    value:
                                      _vm.pageData.activeDiagRecord
                                        .treatmentRecord.symContent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.activeDiagRecord
                                          .treatmentRecord,
                                        "symContent",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.activeDiagRecord.treatmentRecord.symContent",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.pageData.type == 4
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "treatment-form-item",
                                    attrs: { label: "四诊" },
                                  },
                                  [
                                    _c("key-word", {
                                      attrs: {
                                        id: "key4",
                                        code: "fdm",
                                        placeholder: _vm.placeholderMap["fdm"],
                                      },
                                      on: {
                                        change: _vm.handleOtherFieldChange,
                                      },
                                      model: {
                                        value:
                                          _vm.pageData.activeDiagRecord
                                            .treatmentRecord.fdmContent,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.pageData.activeDiagRecord
                                              .treatmentRecord,
                                            "fdmContent",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "pageData.activeDiagRecord.treatmentRecord.fdmContent",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "label-con flex flex-row align-center" }, [
      _c("div", { staticClass: "icon" }),
      _c("div", { staticClass: "label" }, [_vm._v("常用")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }